import _ from 'lodash'
import streetApi from '@/api/street'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totalCount: 0,
  errors: [],
  loading: false,
  filters: {
    pageNumber: 1,
    pageSize: 10,
    searchQuery: '',
    cityId: 0,
    sortBy: '',
    sortDesc: false,
  },
}

const getters = {
}

const actions = {
  fetchList({ commit }) {
    state.loading = true
    streetApi.getAll({ ...state.filters })
      .then(({ data }) => commit('SET_LIST', data))
  },
  syncStreets({ commit }) {
    return streetApi.syncByCityId(state.filters.cityId)
      .then(() => commit('STREETS_SYNCED'))
      .catch(error => {
        commit('CITY_SYNC_FAILED', { errors: error.response.data.errors })
        throw error
      })
  },
}

const mutations = {
  SET_LIST(state, { items, metadata }) {
    state.list = items
    state.totalCount = metadata.totalItemCount
    state.loading = false
  },
  CLEAR_ERRORS(state) {
    state.errors = []
  },
  STREETS_SYNCED() {
    store.dispatch('street/fetchList')
    store.dispatch('message/success', 'CITY_STREETS_SYNC.success')
  },
  STREETS_SYNC_FAILED(state, { errors }) {
    store.dispatch('message/error', 'CITY_STREETS_SYNC.failed')
    state.errors = errors
  },
  ...generateFormHandlerMutations(state),
}

const modules = {
}

const watchers = [
  [state => state.street.filters, _.debounce(async () => await store.dispatch('street/fetchList'), 250), { immediate: false, deep: true }],
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
